<template>
  <MModal
    :show="show"
    :aria-label="title"
    :allow-overflow="allowOverflow"
    @close-modal="$emit('close-modal')"
  >
    <MHeading slot="header" size="h4" tag="h2">
      {{ title }}
    </MHeading>
    <slot />
  </MModal>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

import MHeading from '../../../typography/Heading/MHeading.vue'
import MModal from '../MModal.vue'

export default defineComponent({
  name: 'MModalTooltip',
  components: {
    MHeading,
    MModal,
  },
  props: {
    /**
     * Whether the modal is rendered
     */
    show: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      required: true,
    },
    /**
     * Allow elements to overflow the modal
     * This prevents internal scrolling.
     * Ideally only for use in short modals.
     * Useful for MSelectInput dropdowns.
     */
    allowOverflow: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['close-modal'],
})
</script>
